<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col>
            <form ref="fileUpload" :class="['uploadFrom', { dragDropCapable: dragDropCapable, canDropNow: canDropNow }]"
              @click="uploadClick()">
              <input type="file" ref="fileUploadFallback" webkitdirectory directory multiple style="display: none" @change="onFallbackUpload">
                <template v-if="!disabled">
                <div class="uploadHint" v-if="dragDropCapable">
                  <b-button>{{ $dt('sample_set_file_upload.hint_can_drag', 'Drag and Drop the files here or click to upload!') }}</b-button>
                </div>
                <div class="uploadHint" v-else>
                  <b-button>{{ $dt('sample_set_file_upload.hint_can_drag', 'Click to upload!') }}</b-button>
                </div>
              </template>
            </form>
          </b-col>
          <!-- <b-col  md="auto" class="mb-2 pl-0">
            <b-btn variant="primary" class="h-100 m-0 px-3">Upload</b-btn>
          </b-col> -->
        </b-row>

      <b-card bg-variant="light" class="mb-2">
        <b-row>
          <b-col>
              <b-form-checkbox :disabled="isUploading" v-model="groupByRegex" class="mb-2">{{ $dt('sample_set_file_upload.group_by_regex', 'Group into samples by regex') }}</b-form-checkbox>
              <b-form-input :disabled="!groupByRegex || isUploading" :placeholder="$dt('sample_set_file_upload.group_regex_placeholder', 'group_by regex')" v-model="groupRegex"></b-form-input>
          </b-col>
          <b-col>
            <b-form-group :label="$t('sample_set_file_upload.tags')">
              <treeselect
                :placeholder="$t('sample_set_file_upload.placeholders.tags')"  :disabled="isUploading"
                :multiple="true" :load-options="autocompleteTag" :async="true" :defaultOptions="true" v-model="tags4All"/>
            </b-form-group>
         </b-col>
          <b-col>
              <b-form-checkbox :disabled="isUploading" v-model="checkDuplicates" class="mb-2">{{ $dt('sample_set_file_upload.checkDuplicates', 'Check for duplicates') }}</b-form-checkbox>
              <b-form-checkbox :disabled="isUploading || !checkDuplicates" v-model="doNotImportDuplicates" class="mb-2">{{ $dt('sample_set_file_upload.doNotImportDuplicates', 'Do not import if duplicates found') }}</b-form-checkbox>
          </b-col>
          <b-col>
              <b-form-checkbox :disabled="isUploading" v-model="tagByRegex" class="mb-2">{{ $dt('sample_set_file_upload.tag_by_regex', 'Get tags by regex') }}</b-form-checkbox>
              <b-form-input :disabled="!tagByRegex || isUploading" :placeholder="$dt('sample_set_file_upload.tag_regex_placeholder', 'tag_by regex')" v-model="tagRegex"></b-form-input>
          </b-col>
        </b-row>
      </b-card>

      <!-- <b-btn variant="primary" block :disabled="samples.length===0" class="mb-2">Upload</b-btn> -->

    <b-button-group class="mb-2 btn-group-justified">
      <b-btn  @click="upload" variant="primary" :disabled="isUploading || samples.length === 0">{{ $dt('sample_set_file_upload.upload_btn', 'Upload') }}</b-btn>
      <b-btn  @click="clearAll" :variant="(isUploading && isUploadDone) ? 'success' : 'secondary'" :disabled="(isUploading && !isUploadDone) || samples.length === 0">{{ $dt('sample_set_file_upload.clear_btn', 'Clear list') }}</b-btn>
    </b-button-group>

    <b-progress v-if="uploadProgress" class="mb-2" :max="uploadProgress.count" show-value>
      <b-progress-bar :value="uploadProgress.done" variant="success"></b-progress-bar>
      <b-progress-bar :value="uploadProgress.processing" variant="primary" animated></b-progress-bar>
    </b-progress>

      <b-list-group>
        <b-list-group-item v-for="(sample, key) in samples" :key="key" class="flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">
                <b-spinner v-if="samplesFinal && samplesFinal[key]._uploading" type="grow" variant="primary"/>
                <i v-if="samplesFinal && !samplesFinal[key]._skipped && samplesFinal[key]._uploaded" class="mx-1 fa fa-check fa-lg text-success"/>
                <i v-if="samplesFinal && samplesFinal[key]._skipped" class="mx-1 fa fa-times fa-lg text-secondary"/>
                {{ sample.name }} <b-badge v-for="sample_tag in sample.tags_by_name" v-bind:key="sample_tag">{{ sample_tag }}</b-badge>
            </h5>
            <small>{{ sample.files.length }} files</small>
          </div>
          <b-list-group>
            <b-list-group-item v-for="(file, key2) in sample.files" :key="`${key}.${key2}.${file.name}`" class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <p class="mb-1">
                  <b-spinner v-if="checkDuplicates && file.duplicate === null" variant="primary" small/>
                  <b-badge v-if="file.duplicate && file.duplicate.in_this_set" variant="danger" class="mx-1">{{ $dt('sample_set_file_upload.duplicate_in_set', 'Duplicate in this set') }}</b-badge>
                  <b-badge v-if="file.duplicate && file.duplicate.in_project" variant="warning" class="mx-1">{{ $dt('sample_set_file_upload.duplicate_in_project', 'Duplicate in project') }}</b-badge>
                  {{ file.name }}
                </p>
                <span>
                  <small>{{ file.full_path }}</small>
                  <i v-if="!isUploading" @click="removeFile(file.tid)" class="ml-1 fa fa-times fa-lg text-danger"/>
                </span>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-list-group-item>
      </b-list-group>
      </b-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import { mapGetters, mapActions, mapState } from 'vuex';
import Vue from 'vue';
import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { fileIconMap, fileIconColor } from '@/shared/classes';
import Services from '@/services/index';
import MD5 from '@/shared/md5';

import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  mounted() {
    this.dragDropCapable = this.checkIfDragDropCapable();
    this.initDragDropCapability();
  },
  props: {
    id: { type: Number, default: null },
    disabled: { type: Boolean, default: false },
    defaultFileInfo: {
      type: Object,
      default() {
        return {

        };
      }
    },
  },
  data() {
    return {
      dragDropCapable: false,
      canDropNow: false,
      tmpUrls: {},
      // tableFields: [
      //   // { key: 'id', sortable: true, label: this.$t('global.id') },
      //   { key: 'group', sortable: true, label: this.$dt('sample_set_file_upload.group', 'Group') },
      //   { key: 'same_group' },
      //   { key: 'full_path', sortable: true, label: this.$dt('sample_set_file_upload.full_path', 'Full Path') },
      //   { key: 'name', sortable: true, label: this.$dt('sample_set_file_upload.name', 'Name') },
      //   { key: 'file_name', sortable: true, label: this.$dt('sample_set_file_upload.file_name', 'File name') },
      //   { key: 'human_readable_size', sortable: true, label: this.$dt('sample_set_file_upload.human_readable_size', 'Size') },
      //   { key: 'options', label: this.$dt('sample_set_file_upload.options', ' ') }
      // ],
      list: [],
      samplesFinal: null,
      fileIconMap,
      fileIconColor,
      // filters: {
      //   sort_field: null,
      //   sort_order: null,
      // },
      groupByRegex: false,
      tagByRegex: false,
      groupRegex: '^(?<group>.*)?\\/([^/]*)$',
      tagRegex: '^(?<tag>.*)?\\/([^/]*)$',
      uploadConcurency: 3,
      currentConcurrentUploads: 0,

      tags4All: [],
      checkDuplicates: true,
      doNotImportDuplicates: false,
      tid: 0, // for unique file identification
      uploadFailedMessage: null,
    };
  },
  components: {
    Treeselect
  },
  computed: {
    isUploading() { return this.samplesFinal !== null; },
    isUploadDone() { return this.uploadProgress && this.uploadProgress.count === this.uploadProgress.done; },
    uploadProgress() {
      if (this.samplesFinal === null) return null;
      return Object.values(this.samplesFinal).reduce((stats, sample) => {
        stats.count++;
        if (sample._uploading) stats.processing++;
        if (sample._uploaded) stats.done++;
        return stats;
      }, { count: 0, done: 0, processing: 0 });
    },
    samples() {
      if (this.samplesFinal !== null) return this.samplesFinal;
      let data = this.list || [];

      if (this.groupByRegex || this.tagByRegex) {
        let regT; let regG;
        if (this.tagByRegex) { regT = new RegExp(this.tagRegex); }
        if (this.groupByRegex) { regG = new RegExp(this.groupRegex); }
        data = data.map((f) => {
          if (this.tagByRegex) {
            const regRes = regT.exec(f.full_path);
            if ((regRes && regRes.groups && regRes.groups.tag)) {
              f.tag = regRes.groups.tag;
              if (this.groupByRegex) {
                const regRes = regG.exec(f.full_path);
                f.group = (regRes && regRes.groups && regRes.groups.group) ? regRes.groups.group : 'no_group';
              } else { f.group = f.name; }
            }
          } else {
            const regRes = regG.exec(f.full_path);
            f.group = (regRes && regRes.groups && regRes.groups.group) ? regRes.groups.group : 'no_group';
          }
          return f;
        });
        data.sort((a, b) => {
          if (a.group < b.group) return -1;
          if (a.group > b.group) return 1;
          return 0;
        });
      } else {
        data = data.map((f) => { f.group = f.name; f.tag = ''; return f; });
      }

      const samples = data.reduce((s, f) => {
        if (!(f.group in s)) {
          s[f.group] = Vue.observable({
            name: f.group, // should be f.name?
            key: f.group,
            tags_by_name: new Set(),
            tags: [],
            files: []
          });
        }
        s[f.group].files.push(f);
        if (f.tag) { s[f.group].tags_by_name.add(f.tag); }
        return s;
      }, {});
      return samples;
    },
    ...mapState('Auth', ['activeProjectId']),
  },
  watch: {
    page: 'getData',
    // filters: { deep: true, handler: 'getData' },
    activeProjectId: function () {
      if (this.activeProjectId) this.getData();
    },
    uploadFailedMessage() {
      if (this.uploadFailedMessage) {
        this.alertError({ title: 'Upload error', text: this.uploadFailedMessage });
      }
    },
  },
  methods: {
    removeFile(tid) {
      this.list = this.list.filter((f) => f.tid !== tid);
    },
    clearAll() {
      this.list = [];
      this.samplesFinal = null;
    },
    upload() {
      // this.uploadNext(); // todo remove
      if (this.samplesFinal || this.samples.length === 0) return;
      this.samplesFinal = Vue.observable(this.samples);
      // this.cq = cq().limit({ concurrency: 2 }).process((sample) => {
      //   return this.uploadSample(sample);
      // });
      const uploadSampleLoop = () => {
        this.uploadSample().then(() => {
          uploadSampleLoop();
        }).catch(() => { });
      };
      this.currentConcurrentUploads = 0;
      while (this.currentConcurrentUploads < this.uploadConcurency) {
        uploadSampleLoop();
        this.currentConcurrentUploads++;
      }
    },

    uploadSample() {
      if (!this.samplesFinal || this.samples.length === 0) return Promise.reject();
      const sample = Object.values(this.samples).find((s) => !s._uploaded && !s._uploading);
      if (!sample) return Promise.reject();

      sample._uploading = true;
      sample._uploaded = 0.0;
      sample.tags = [...new Set([...sample.tags, ...this.tags4All])];
      sample.tags_by_name = [...new Set([...sample.tags_by_name])];

      sample.project_id = this.activeProjectId;
      sample.sample_set_id = this.id;
      if (this.doNotImportDuplicates) {
        sample.files = sample.files.filter((f) => !f.duplicate);
      }
      if (sample.files.length === 0) {
        sample._skipped = true;
        sample._uploaded = true;
        sample._uploading = false;
        this.samplesFinal = { ...this.samplesFinal };
        return Promise.resolve();
      }

      this.samplesFinal = { ...this.samplesFinal };
      return new Promise((resolve) => {
        Services.samples.upload(this.activeProjectId, this.id, sample).then(() => {
          sample._uploaded = true;
          sample._uploading = false;
          this.samplesFinal = { ...this.samplesFinal };
          resolve();
        }).catch((e) => {
          sample._uploaded = true;
          sample._uploading = false;
          this.samplesFinal = { ...this.samplesFinal };
          if (e?.errors) {
            this.uploadFailedMessage = e?.errors[0];
          }
          resolve();
        });
      });
    },

    autocompleteTag({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        Services.tags.list({ notpaginate: 1, search: searchQuery }).then(({ data }) => {
          const options = data.data.map((i) => ({
            id: i.id,
            label: `${i.id} ${i.name}`,
          }));
          callback(null, options);
        });
      }
    },

    itemUrl(fileInfo) {
      // if (this.itemIcon(fileInfo)) return false;
      // if (fileInfo.id && (!(fileInfo.cloneModelId || this.id) || !this.contractId || !this.model)) return ''; // unknown safeguard
      // if (fileInfo.id) {
      //   return `${Backend.defaults.baseURL}contracts/${this.contractId}/media/${this.model}/${fileInfo.cloneModelId || this.id}/${fileInfo.id}?token=${this.token}`; // unknown
      // }
      // if ((!fileInfo.turlid || !this.tmpUrls[fileInfo.turlid]) && fileInfo.file && this.itemIcon(fileInfo) === false) {
      //   fileInfo.turlid = uuidv4(); // temporary url id
      //   this.tmpUrls[fileInfo.turlid] = URL.createObjectURL(fileInfo.file);
      // }
      // if (fileInfo.turlid && this.tmpUrls[fileInfo.turlid]) return this.tmpUrls[fileInfo.turlid];
      return false;
    },

    addFileForUpload(file, path) {
      if (this.list.length > 1000) {
        console.warn('max files exceeded');
        return;
      }
      // console.log('add file', file);
      const fileInfo = {
        file,
        human_readable_size: this.formatBytes(file.size),
        ...this.defaultFileInfo,
        name: file.name,
        path: path || '',
        full_path: (path || '') + file.name,
        tag: '',
        file_name: file.name,
        duplicate: null,
        tid: this.tid,
      };
      this.tid += 1;

      const reader = new FileReader();
      reader.onloadend = () => {
        fileInfo.hash = MD5(reader.result).toString();
        // console.log(fileInfo.hash);
        Services.samples.fileExists(this.activeProjectId, this.id, fileInfo.hash).then(({ data }) => {
          // console.log(data);
          fileInfo.duplicate = (data.in_this_set || data.in_project) ? data : false;
        });
      };
      reader.readAsBinaryString(file);

      this.list.push(fileInfo);
    },

    onFallbackUpload(e) {
      for (let i = 0; i < e.target.files.length; i++) {
        this.addFileForUpload(e.target.files[i]);
      }
      this.$refs.fileUpload.reset();
    },
    checkIfDragDropCapable() {
      const div = document.createElement('div');
      return (('draggable' in div)
        || ('ondragstart' in div && 'ondrop' in div))
        && 'FormData' in window
        && 'FileReader' in window;
    },
    initDragDropCapability() {
      if (!this.dragDropCapable) return;

      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach((evt) => {
        this.$refs.fileUpload.addEventListener(evt, (e) => {
          e.preventDefault();
          e.stopPropagation();
        }, false);
      });

      ['dragover', 'dragenter'].forEach((evt) => {
        this.$refs.fileUpload.addEventListener(evt, () => {
          if (this.disabled) return;
          this.canDropNow = true;
        });
      });

      ['dragleave', 'dragend', 'drop'].forEach((evt) => {
        this.$refs.fileUpload.addEventListener(evt, () => {
          this.canDropNow = false;
        });
      });

      this.$refs.fileUpload.addEventListener('drop', (e) => {
        if (this.disabled) return;
        const { items } = e.dataTransfer;
        if (items.length === 1 && items[0].webkitGetAsEntry().isDirectory) {
          // this allows to upload single folder rather than selecting all its contents
          const dirReader = items[0].webkitGetAsEntry().createReader();
          dirReader.readEntries((entries) => {
            for (let i = 0; i < entries.length; i++) {
              this.traverseFileTree(entries[i]);
            }
          });
        } else {
          // if multiple folders or files then parse all as usual
          for (let i = 0; i < items.length; i++) {
            const item = items[i].webkitGetAsEntry();
            if (item) {
              this.traverseFileTree(item);
            }
          }
        }
      });
    },
    traverseFileTree(item, path) {
      path = path || '';
      if (item.isFile) {
        // Get file
        item.file((file) => {
          this.addFileForUpload(file, path);
          // console.log('File:', path + file.name);
        });
      } else if (item.isDirectory) {
        // Get folder contents
        const dirReader = item.createReader();
        dirReader.readEntries((entries) => {
          for (let i = 0; i < entries.length; i++) {
            this.traverseFileTree(entries[i], `${path + item.name}/`);
          }
        });
      }
    },
    uploadClick() {
      if (this.disabled) return;
      this.$refs.fileUploadFallback.click();
    },
    formatBytes(a, b = 2) {
      if (a === 0) return '0 Bytes'; const c = b < 0 ? 0 : b; const
        // eslint-disable-next-line no-restricted-properties
        d = Math.floor(Math.log(a) / Math.log(1024)); return `${parseFloat((a / Math.pow(1024, d)).toFixed(c))} ${['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][d]}`;
    },

  },
  destroyed() {
    Object.values(this.tmpUrls).forEach((url) => URL.revokeObjectURL(url));
  }
};
</script>

<style scoped lang=scss>
.btn-group-justified {
  width: 100%;
}

.uploadFrom {
  display: block;
  min-height: 2.5em;
  background-color: $dark;
  border: solid 1px $light;
  margin: auto;
  margin-bottom: 0.5em;

  /* margin-top: 40px; */
  border-radius: 4px;
}

.uploadFrom .uploadHint {
  text-align: center;
  padding: 0.5em;
  font-size: 1.2em;
}

.file-row {
  background-color: $light;
  border: solid 1px $secondary;
  border-radius: 4px;
  padding: 0.5em;
  margin: 0.5em;
}

.file-row.unsavedFile {
  border-color: $green;
}

.file-row.deletedFile {
  border-color: $red;
  color: $red;
}

.uploadFrom.canDropNow {
  background-color: $green;
}

.img-thumbnail.img-preview {
  /* display:inline-block; */
  border: 1px solid $dark;
  border-radius: 4px;
  padding: 2px;
  width: 130px;
  height: 130px;
}

.icon-preview {
  color: $dark;
  vertical-align: middle;
  font-size: 130px;
}

.preview-thumbnail {
  margin-left: 1em;
  min-width: 110px;
  display: inline-block;
  text-align: center;
}

.icon-color-blue {
  color: $secondary;
}

.icon-color-yellow {
  color: $yellow;
}

.icon-color-green {
  color: $green;
}

.icon-color-red {
  color: $red;
}

.icon-color-pink {
  color: $light;
}

.wide-datepicker.mx-datepicker {
  min-width: 210px;
  width: auto;
  display: block;
}

.col-inputs {
  min-width: 320px;
}

.col-options {
  min-width: 120px;
}

.col-min-info {
  min-width: 170px;
}
</style>
